import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Modal,Radio} from 'react-bootstrap';
import SelectAsync from 'react-select/lib/Async';
import {connect} from 'react-redux';
import {personFullName} from "../../../../services/Api";
import PropTypes from 'prop-types';
import moment from 'moment';
import Datepicker from "react-datepicker/es";
import './styles.css';
import _ from "lodash";

class AnnuityPaymentFormModal extends React.Component{

    loadingId = '@Class.AnnuityPaymentForm.annuityPayment.create';

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ){
        super(props);
        let {type} = this.props;

        if( !props.editing) { //CREANDO
            let membership;
            if( props.person && props.membership ) {
                membership = {label: personFullName(props.person), value: props.membership.id};
            }
            this.state = {
                form: {
                    paymentDate: moment(),
                    year: moment().year(),
                    membership,
                    type:type
                },
                files: [{}]
            };
        }
        else {
            const membership = props.editing.membership? props.editing.membership : props.membership;
            const person = props.editing.membership? props.editing.membership.person : props.person;
            this.state = {
                form: {
                    membership: {label: personFullName(person), value: membership.id},
                    paymentDate: moment(props.editing.paymentDate),
                    year: props.editing.year,
                    files: props.editing.files,
                    type:type
                },
                files: [{}]
            };
        }
        this.loadPeople= _.debounce(this.loadPeople, 450);

    }

    onFormChange = ({target})=>{
        if( target.type !== 'file' )
            this.setState( { form: { ...this.state.form, [target.name]:target.value}} );
        else {
            const files = [...this.state.files];
            files[ target.dataset.index ] = target.files;
            this.setState({files});
        }
    };

    getFormValue = ( name )=>{
        return this.state.form[name]? this.state.form[name]:'';
    };

    addFile = ()=>{
        this.setState( {files: [...this.state.files,{}] } );
    };

    removeOldFile = ( e )=>{
        const index = Number(e.target.dataset.index);
        const oldFiles = [...this.state.form.files];

        oldFiles.splice( index, 1 );

        this.setState( {form: {...this.state.form, files:oldFiles } } );
    };

    loadPeople = ( name )=>{
        return this.context.api.people.getSimple( 0, 10, undefined, {orSearch_fullname:name, 'membership[exists]': true})
            .then( (people=[])=> people.map( (person)=>({value:person.membership.id, label: personFullName(person) }) ) )
    };

    saveForm = ()=>{
        if( !this.state.form.membership || !this.state.form.paymentDate || !this.state.form.type){
            this.context.notifier.error('No has llenado todos los campos');
            return;
        }

        const payment = { ...this.state.form };
        payment.paymentDate = payment.paymentDate.format('YYYY-MM-DD');
        payment.membership = payment.membership.value;
        payment.year = Number(payment.year);

        if( payment.files )
            payment.files = payment.files.map( (file)=>file.id );

        //Get all File s from the FileList s inside the files object of the state
        const files = [];
        for( let i=0; i<this.state.files.length; i++)
            if( this.state.files[i] && this.state.files[i].length )
                for( let j=0; j<this.state.files[i].length; j++)
                    files.push( this.state.files[i][j] )

        const finish = ()=>{
                    if( this.props.didSave )
                        this.props.didSave();
                    else if( this.props.onHide )
                        this.props.onHide();
                };
        payment.type=this.state.form.type;
        if( this.props.editing )
            this.context.api.annuityPayments.edit(this.props.editing.id, payment, this.loadingId, files ).then(finish);
        else
            this.context.api.annuityPayments.create( payment, this.loadingId, files ).then(finish);
    };

    render(){

        const { onHide } = this.props;
        return (
            <Modal
                show={true}
                onHide={ onHide }>

                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing?'Editar ':'Añadir nuevo '} pago {this.state.form.type==='membership' &&' de membresía'}{this.state.form.type==='ihs' &&' de IHS'}</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <Form className='AnnuityPaymentForm'>
                        <FormGroup>
                            <ControlLabel>Miembro:</ControlLabel>
                            <SelectAsync
                                cacheOptions
                                placeholder='Nombre del miembro'
                                noOptionsMessage={()=>"Sin coincidencias"}
                                loadOptions={this.loadPeople}
                                onChange={(value)=>this.onFormChange({target:{name:"membership", value}}) }
                                value={ this.getFormValue('membership') }
                        />
                        </FormGroup>
                        {this.props.type===undefined &&
                            <FormGroup>
                                <ControlLabel>Tipo de Pago: &nbsp; </ControlLabel>
                                <Radio
                                    inline
                                    name="type"
                                    value={this.getFormValue('type')}
                                    onChange={()=>this.onFormChange({target:{name:"type", value:"membership"}})}
                                >Membresía</Radio>
                                <Radio
                                    inline
                                    name="type"
                                    value={this.getFormValue('type')}
                                    onChange={()=>this.onFormChange({target:{name:"type", value:"ihs"}})}
                                >IHS</Radio>
                            </FormGroup>
                        }

                        <FormGroup>
                            <ControlLabel>Anualidad {this.state.form.type==='membership'&& ' de membresía'}{this.state.form.type==='ihs'&&' de IHS'} a pagar:</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Año"
                                name="year"
                                onChange={this.onFormChange}
                                value={this.getFormValue('year')}
                            >
                                { availableYears().map( (year)=>
                                    <option value={year} key={year}>{year}</option>
                                )}
                            </FormControl>
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Fecha de pago:</ControlLabel>
                            <Datepicker
                                dropdownMode={'select'}
                                className='form-control'
                                selected={this.getFormValue('paymentDate')||null}
                                onChange={(date)=>this.onFormChange({target:{name:'paymentDate',value:date}})} />

                        </FormGroup>

                        { this.props.editing && this.state.form.files && this.state.form.files.length?
                        <FormGroup>
                            <ControlLabel>Archivos:</ControlLabel>
                            {
                                this.state.form.files.map( (file, index)=>
                                    <p key={file.id}>{file.originalName} <i className='fa fa-trash delete-file' data-index={index} onClick={this.removeOldFile}/></p>
                                )
                            }
                        </FormGroup>
                            :null}

                        <FormGroup>
                            <ControlLabel>Agregar archivos (factura o comprobante):</ControlLabel>
                            {this.state.files.map( (f,i)=>
                                <FormControl type='file' data-index={i} key={i} onChange={this.onFormChange}/>
                            )}
                            <a onClick={this.addFile}>Añadir otro archivo</a>
                        </FormGroup>

                        <Button
                            bsStyle='danger'
                            onClick={this.props.onHide}
                            disabled={this.props.loadingIds[this.loadingId]}>
                            Cancelar</Button>
                        <Button
                            bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}
                            disabled={this.props.loadingIds[this.loadingId]}>Guardar</Button>

                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

const availableYears = ()=>{
    const initial  = 2018;
    const actual = moment().year();

    const years = [];
    for( let i=initial; i<=actual+3; i++) years.push( i );

    return years;
};

const mapStateToProps = ( { api:{simplePeople=[]}, loadingIds } )=>({simplePeople, loadingIds});

export default connect(mapStateToProps)(AnnuityPaymentFormModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/AnnuityPaymentFormModal/index.js